import { render, staticRenderFns } from "./AddServiceMenu.vue?vue&type=template&id=2e917434"
import script from "./AddServiceMenu.vue?vue&type=script&lang=js"
export * from "./AddServiceMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports